module.exports = __webpack_public_path__ + "assets/1560291bec2e7b52654f80d38d1b4c7a.woff";